export default __webpack_public_path__ + "static/media/Helm of Bloodlust.cc68f9e5.jpg";